import { INLINES, BLOCKS } from '@contentful/rich-text-types';

const renderOptions = {
    renderText: text =>
        text.split('\n').reduce((children, textSegment, index) => {
            return [...children, index > 0 && <br key={index} />, textSegment];
        }, []),
    renderNode: {
        [INLINES.HYPERLINK]: (node, children) => {
            const { uri } = node.data;
            return (
                <a href={uri} target="_blank" rel="noopener noreferrer">
                    {children}
                </a>
            );
        },
        [INLINES.ASSET_HYPERLINK]: (node, children) => {
            const file = node.data.target?.fields?.file;
            const url = file?.url;
            if (!url) return children;

            // Check if it's a PDF for inline opening vs direct download
            const isPdf = file.contentType === 'application/pdf';

            return (
                <a
                    href={`https:${url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    download={!isPdf}
                >
                    {children}
                </a>
            );
        },
        [INLINES.ENTRY_HYPERLINK]: (node, children) => {
            const fields = node.data.target?.fields;
            // Common fields in Contentful entries often used for internal linking
            const url = fields?.url || fields?.slug;

            if (url) {
                return (
                    <a href={url.startsWith('/') ? url : `/${url}`}>
                        {children}
                    </a>
                );
            }

            return children;
        },
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
            const { file, title } = node.data.target.fields;
            const url = file?.url;
            if (!url) return null;

            if (file.contentType.includes('image')) {
                return <img src={`https:${url}`} alt={title} style={{ maxWidth: '100%' }} />;
            }
            return null;
        }
    },
};

export default renderOptions;